const Resync = () => (
  <svg focusable={false} viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'>
    <mask id='a' fill='#fff'>
      <rect fill='#fff' fillRule='evenodd' height='40' rx='20' width='40' />
    </mask>
    <g fill='none' fillRule='evenodd' transform='matrix(0 -1 1 0 0 40)'>
      <rect
        height='38.4'
        rx='19.2'
        stroke='#E3E6E8'
        strokeWidth='1.6'
        width='38.4'
        x='.8'
        y='.8'
      />
      <g mask='url(#a)'>
        <g transform='matrix(0 1 -1 0 32 8)'>
          <path
            d='m12.9393398 6.75h-.9393398c-3.45177969 0-6.25 2.79822031-6.25 6.25 0 3.4517797 2.79822031 6.25 6.25 6.25 3.4517797 0 6.25-2.7982203 6.25-6.25 0-.4142136.3357864-.75.75-.75s.75.3357864.75.75c0 4.2802068-3.4697932 7.75-7.75 7.75-4.28020681 0-7.75-3.4697932-7.75-7.75 0-4.28020681 3.46979319-7.75 7.75-7.75h.9393398l-.7196699-.71966991c-.2928932-.29289322-.2928932-.76776696 0-1.06066018.2928932-.29289321.767767-.29289321 1.0606602 0l2 2c.2928932.29289322.2928932.76776696 0 1.06066018l-2 2c-.2928932.29289321-.767767.29289321-1.0606602 0-.2928932-.29289322-.2928932-.76776696 0-1.06066018z'
            fill='#fff'
            fillRule='nonzero'
          />
          <path
            d='m8.93933983 3.75h-.93933983c-3.45177969 0-6.25 2.79822031-6.25 6.25 0 3.4517797 2.79822031 6.25 6.25 6.25 3.4517797 0 6.25-2.7982203 6.25-6.25 0-.41421356.3357864-.75.75-.75s.75.33578644.75.75c0 4.2802068-3.4697932 7.75-7.75 7.75-4.28020681 0-7.75-3.4697932-7.75-7.75 0-4.28020681 3.46979319-7.75 7.75-7.75h.93933983l-.71966992-.71966991c-.29289321-.29289322-.29289321-.76776696 0-1.06066018.29289322-.29289321.76776696-.29289321 1.06066018 0l2.00000001 2c.2928932.29289322.2928932.76776696 0 1.06066018l-2.00000001 2c-.29289322.29289321-.76776696.29289321-1.06066018 0-.29289321-.29289322-.29289321-.76776696 0-1.06066018z'
            fill='#E3E6E8'
            transform='translate(4 3)'
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Resync;
